import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['dataset', 'title', 'height'],
  data () {
    return {
    }
  },
  computed: {},
  methods: {
    prepareDataSet (dataset) {
      return [{
        label: 'Amazon',
        borderColor: '#f39c12',
        pointBackgroundColor: '#f39c12',
        borderWidth: 1,
        pointBorderColor: '#f39c12',
        data: this.prepareData(dataset, 'amazon'),
        height: 330,
        backgroundColor: this.gradient
      }, {
          label: 'schuhe.de',
          borderColor: '#EE379A',
          pointBackgroundColor: '#EE379A',
          borderWidth: 1,
          pointBorderColor: '#EE379A',
          data: this.prepareData(dataset, 'schuhede'),
          height: 330,
          backgroundColor: this.gradient2
        }, {
        label: 'Zalando',
        borderColor: '#DB321B',
        pointBackgroundColor: '#DB321B',
        borderWidth: 1,
        pointBorderColor: '#DB321B',
        data: this.prepareData(dataset, 'zalando'),
        height: 330,
        backgroundColor: this.gradient3
      }, {
        label: 'eBay',
        borderColor: '#00c0ef',
        pointBackgroundColor: '#00c0ef',
        borderWidth: 1,
        pointBorderColor: '#00c0ef',
        data: this.prepareData(dataset, 'ebay'),
        height: 330,
        backgroundColor: this.gradient4
      }]
    },
    prepareData (collection, key) {
      let ret = []
      Object.keys(collection).forEach(o => {
        Object.keys(collection[o]).sort().forEach(k => {
          ret.push(collection[o][k].channels[key].total)
        })
      })
      return ret
    },
    prepareLabels (collection) {
      let ret = []
      Object.keys(collection).forEach(o => {
        for (let k in collection[o]) {
          ret.push(k)
        }
      })
      return ret.sort()
    }
  },
  mounted () {
    this.gradient = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 450)
    this.gradient.addColorStop(0, 'rgba(243, 156, 18, 0.5)')
    this.gradient.addColorStop(0.5, 'rgba(243, 156, 18, 0.25)')
    this.gradient.addColorStop(1, 'rgba(243, 156, 18, 0)')

    this.gradient2 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 450)
    this.gradient2.addColorStop(0, 'rgba(238, 55, 154, 0.5)')
    this.gradient2.addColorStop(0.5, 'rgba(238, 55, 154, 0.25)')
    this.gradient2.addColorStop(1, 'rgba(238, 55, 154, 0)')

    this.gradient3 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 450)
    this.gradient3.addColorStop(0, 'rgba(219, 50, 27, 0.5)')
    this.gradient3.addColorStop(0.5, 'rgba(219, 50, 27, 0.25)')
    this.gradient3.addColorStop(1, 'rgba(219, 50, 27, 0)')

    this.gradient4 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 450)
    this.gradient4.addColorStop(0, 'rgba(0, 192, 239, 0.5)')
    this.gradient4.addColorStop(0.5, 'rgba(0, 192, 239, 0.25)')
    this.gradient4.addColorStop(1, 'rgba(0, 192, 239, 0)')
  },
  watch: {
    dataset () {
      this.$data._chart && this.$data._chart.destroy()
      let month = Object.keys(this.dataset)[0].split('-')[0] - 1
      let year = Object.keys(this.dataset)[0].split('-')[1]
      let dateRange = Object.keys(this.dataset[Object.keys(this.dataset)[0]]).sort()
      this.renderChart({
        labels: this.prepareLabels(this.dataset),
        datasets: this.prepareDataSet(this.dataset)
      }, {
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            scaleLabel: {
              display: true,
              labelString: 'Tag'
            }
          }],
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              callback: (label, index, labels) => {
                return label
              },
              suggestedMin: 0
            },
            scaleLabel: {
              display: true,
              labelString: 'Anzahl'
            }
          }]
        },
        title: {
          display: true,
          fontSize: 14,
          text: dateRange[0] + ' - ' + dateRange[dateRange.length - 1] + ', ' + this.$options.filters.translate(moment().month(month).format('MMMM'), this.$store.getters.language) + ' ' + year,
          fontStyle: 'bold',
          fontColor: '#FFFFFF'
        },
        legend: {
          display: true
        },
        responsive: true,
        hover: {
          mode: 'x',
          intersect: false
        },
        maintainAspectRatio: false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/Charts/SalesReportChart.js